import { type FormEvent, type JSX, useState } from "react";
import { useDispatch } from "react-redux";
import { useMutation } from "urql";
import * as API from "../../api/Upload";
import { loadJSData } from "../../shared/jsData";
import t from "../../shared/translations";
import { graphql } from "../gql";
import { closeModal, type Dispatch } from "../state";
import { Button } from "./stylins";

const editPictureMutation = graphql(`
    mutation AppProfileEditPictureMutation($filename: String!) {
        currentPersonEditPicture(filename: $filename) {
            error
            currentPerson { id }
        }
    }
`);

function PictureForm(): JSX.Element {
    const [file, setFile] = useState<File | null>(null);
    const dispatch = useDispatch<Dispatch>();
    const [apiError, setApiError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [_, executeMutation] = useMutation(editPictureMutation);

    const onChange = (event: FormEvent<HTMLInputElement>) => {
        setFile(event.currentTarget.files?.[0] ?? null);
    };

    const onClick = async () => {
        if (submitting) {
            return;
        }
        setApiError("");
        setSubmitting(true);
        let filename: Awaited<ReturnType<typeof API.uploadFile>>;
        try {
            filename = await API.uploadFile(file, "image");
        } catch (err) {
            setApiError(err.message);
            setSubmitting(false);
            return;
        }
        const result = await executeMutation({ filename });
        setSubmitting(false);
        if (result.error) {
            setApiError(result.error.message);
        } else if (result.data?.currentPersonEditPicture?.error) {
            setApiError(result.data.currentPersonEditPicture.error);
        } else {
            dispatch(closeModal());
        }
    };

    return (
        <div>
            <h3>{t("player.profile.heading-upload-profile-picture")}</h3>
            <input type="file" accept={loadJSData().formats.image_formats.join(",")} onChange={onChange} />
            <Button onClick={onClick} disabled={!file || submitting}>
                {t("player.profile.form-picture-submit")}
            </Button>
            <p>{t("player.profile.info-profile-picture-limit")}</p>
            {apiError && <div className="error">{apiError}</div>}
        </div>
    );
}

export default PictureForm;
